export default __webpack_public_path__ + "static/media/ic_new_zealand.1841f5c5.svg";